import React, { PureComponent } from 'react'
import './calendarOrderInfo.scss'
import Circle from '../../../elements/circle'

class CalendarOrderInfo extends PureComponent {
  render () {
    if (!this.props.info) {
      console.error('CalendarOrderInfo requires info prop')
    }

    const { info } = this.props
    let activeClass = this.props.active ? ' active' : ''
    return (
      <div className={'calendar-order-info'}>
        <div className={'calendar-order-info__content' + activeClass}>
          <div onClick={this.props.onHeaderClick} className='calendar-order-info__content__title ellipsis'>{info.Identity} {info.IsWorkedOn !== undefined && info.IsWorkedOn && <Circle size='t' color='brand-2' />}</div>
          {this.props.children}
        </div>
      </div>
    )
  }
}

CalendarOrderInfo.defaultProps = {
  onHeaderClick: () => {},
  active: false
}

export default CalendarOrderInfo



// WEBPACK FOOTER //
// ./src/app/shared/components/Calendar/calendarOrderInfo/index.js